// Custom JS Palo Alto by Reg, July 2022


const defaultSwiperOptions = {
  // Optional parameters
  // loop: true,

  // pagination: {
  //   el: '.swiper-pagination',
  // },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  slidesPerView: 1,
  breakpoints: {
    600: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
   
  }

  // And if we need scrollbar
  // scrollbar: {
  //   el: '.swiper-scrollbar',
  // },
}


/* 
// ============ toggleParent ========== //
*/


function toggleParent(el) {
  var parentEl = el.parentElement;
  if(parentEl) parentEl.classList.toggle("is--expanded");
  return true
}

function debounce_loading(func, timeout = 300){
  let timer;
  return (...args) => {
    if (!timer) {
      func.apply(this, args);
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      timer = undefined;
    }, timeout);
  };
}

function handleSwiperResize() {
  const allSwipers = document.querySelectorAll('.mySwiper');
  if(allSwipers.length > 0) {
    
    allSwipers.forEach((slider)=>{

      // setTimeout(()=>{
        var heightArr = [];
        const slideItems = slider.querySelectorAll('.swiper-slide');
        slideItems.forEach((slide) => {
          const h = slide.querySelector('.grid-item').offsetHeight;
          heightArr.push(h)
        });
        const maxHeight = Math.max(...heightArr);
        slider.parentElement.style.minHeight = maxHeight + "px";
        slider.children[0].style.minHeight = maxHeight + "px";
      // },100)
    });

  }
}

function initSwiperSliders() {

  var allSwipers = document.querySelectorAll('.swiper');
  if(allSwipers.length > 0) {
    allSwipers.forEach((swipe)=>{
      const id = swipe.getAttribute('id');
      const _slidesPerView = swipe.getAttribute('data-slides-per-view');
      const swiper = new Swiper(`#${id}`, {
        ...defaultSwiperOptions,
        navigation: {
          nextEl: `.swiper-button-next--${id}`,
          prevEl: `.swiper-button-prev--${id}`,
        },
        breakpoints: {
          600: {
            slidesPerView: _slidesPerView ? _slidesPerView * 1 : 3,
            spaceBetween: 20,
          }
        }

      })
    })
  }

}


var variantId = undefined;

function swymCallbackFn(swat) {
console.log(swat)
  // const parentBtn = $(`.wishlist-btn[data-variant-id=${variantId}]`);
  // console.log(variantId)

  // your API calls go here 
  // detect variant change event
  // Based on your theme code - this event detection may be different - this is only a SAMPLE implementation    document.addEventListener("variantChange", function(event) {
      if(variantId !== undefined) { /* the current selected variant id */
      
        window.triggerSwymVariantEvent(variantId);

        const status = window.swymGetCustomerData();
        console.log(status)
        //swat.initializeActionButtons(`.product-wishlist--${variantId}`);/* parent container of the where the button is rendered */
      }
  };


function clickWishlistBtn(e) {

  const product = JSON.parse(e.previousElementSibling.innerHTML)[0];

  variantId = product.variants[0].id;

  if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
  /* Called when swym is loaded! */



  // let formData = {
  //   'items': [{
  //    'id': 36110175633573,
  //    'quantity': 2
  //    }]
  //  };
  //  fetch(window.Shopify.routes.root + 'cart/add.js', {
  //    method: 'POST',
  //    headers: {
  //      'Content-Type': 'application/json'
  //    },
  //    body: JSON.stringify(formData)
  //  })
  //  .then(response => {
  //    return response.json();
  //  })
  //  .catch((error) => {
  //    console.error('Error:', error);
  //  });

}

// function addListenerWishlistButtons() {
//   $('.wishlist-btn').each(function(i){
//     const data = JSON.parse($(this).prev()[0].innerText)[0];
//     console.log(i,data)
//   })
// }

function openModal(e) {
  var data = JSON.parse(e.getAttribute('data-ingredient'));
  // render
  var modalEl = document.getElementById('modal-ingredient');
  if(modalEl) modalEl.classList.remove('hide');
  modalEl.querySelector('.image-modal').innerHTML = data.image;
  modalEl.querySelector('.title-modal').innerText = data.title;
  modalEl.querySelector('.description-modal').innerHTML = data.description;
  var productsLists = "";
  data.products.map((prod) => {
     if(prod.link && prod.title) productsLists += `<li><a href="${prod.link}" target="_blank">${prod.title}</a></li>`;
  });
  modalEl.querySelector('.list-product').innerHTML = productsLists;  
}
function closeModal(e) {
  var modalEl = document.getElementById('modal-ingredient');
  if(modalEl) modalEl.classList.add('hide');
}


function paginator(config) {
    // throw errors if insufficient parameters were given
    if (typeof config != "object")
        throw "Paginator was expecting a config object!";
    if (typeof config.get_rows != "function" && !(config.table instanceof Element))
        throw "Paginator was expecting a table or get_row function!";

    // get/set if things are disabled
    if (typeof config.disable == "undefined") {
        config.disable = false;
    }

    // get/make an element for storing the page numbers in
    var box;
    if (!(config.box instanceof Element)) {
        config.box = document.createElement("div");
    }
    box = config.box;

    // get/make function for getting table's rows
    if (typeof config.get_rows != "function") {
        config.get_rows = function () {
            var table = config.table
            var tbody = table.getElementsByTagName("tbody")[0]||table;

            // get all the possible rows for paging
            // exclude any rows that are just headers or empty
            children = tbody.children;
            var trs = [];
            for (var i=0;i<children.length;i++) {
                if (children[i].nodeType = "tr") {
                    if (children[i].getElementsByTagName("td").length > 0) {
                        trs.push(children[i]);
                    }
                }
            }

            return trs;
        }
    }
    var get_rows = config.get_rows;
    var trs = get_rows();

    // get/set rows per page
    if (typeof config.rows_per_page == "undefined") {
        var selects = box.getElementsByTagName("select");
        if (typeof selects != "undefined" && (selects.length > 0 && typeof selects[0].selectedIndex != "undefined")) {
            config.rows_per_page = selects[0].options[selects[0].selectedIndex].value;
        } else {
            config.rows_per_page = 10;
        }
    }
    var rows_per_page = config.rows_per_page;

    // get/set current page
    if (typeof config.page == "undefined") {
        config.page = 1;
    }
    var page = config.page;

    // get page count
    var pages = (rows_per_page > 0)? Math.ceil(trs.length / rows_per_page):1;

    // check that page and page count are sensible values
    if (pages < 1) {
        pages = 1;
    }
    if (page > pages) {
        page = pages;
    }
    if (page < 1) {
        page = 1;
    }
    config.page = page;
 
    // hide rows not on current page and show the rows that are
    for (var i=0;i<trs.length;i++) {
        if (typeof trs[i]["data-display"] == "undefined") {
            trs[i]["data-display"] = trs[i].style.display||"";
        }
        if (rows_per_page > 0) {
            if (i < page*rows_per_page && i >= (page-1)*rows_per_page) {
                trs[i].style.display = trs[i]["data-display"];
            } else {
                // Only hide if pagination is not disabled
                if (!config.disable) {
                    trs[i].style.display = "none";
                } else {
                    trs[i].style.display = trs[i]["data-display"];
                }
            }
        } else {
            trs[i].style.display = trs[i]["data-display"];
        }
    }

    // page button maker functions
    config.active_class = config.active_class||"active";
    if (typeof config.box_mode != "function" && config.box_mode != "list" && config.box_mode != "buttons") {
        config.box_mode = "button";
    }
    if (typeof config.box_mode == "function") {
        config.box_mode(config);
    } else {
        var make_button;
        if (config.box_mode == "list") {
            make_button = function (symbol, index, config, disabled, active) {
                var li = document.createElement("li");
                var a  = document.createElement("a");
                a.href = "#";
                a.innerHTML = symbol;
                a.addEventListener("click", function (event) {
                    event.preventDefault();
                    this.parentNode.click();
                    return false;
                }, false);
                li.appendChild(a);

                var classes = [];
                if (disabled) {
                    classes.push("disabled");
                }
                if (active) {
                    classes.push(config.active_class);
                }
                li.className = classes.join(" ");
                li.addEventListener("click", function () {
                    if (this.className.split(" ").indexOf("disabled") == -1) {
                        config.page = index;
                        paginator(config);
                    }
                }, false);
                return li;
            }
        } else {
            make_button = function (symbol, index, config, disabled, active) {
                var button = document.createElement("button");
                button.innerHTML = symbol;
                button.addEventListener("click", function (event) {
                    event.preventDefault();
                    if (this.disabled != true) {
                        config.page = index;
                        paginator(config);
                    }
                    return false;
                }, false);
                if (disabled) {
                    button.classList.add("disable");
                }
                if (active) {
                    button.className = config.active_class;
                }
                return button;
            }
        }

        // make page button collection
        var page_box = document.createElement(config.box_mode == "list"?"ul":"div");
        if (config.box_mode == "list") {
            page_box.className = "pagination";
        }

        var left = make_button("&laquo;", (page>1?page-1:1), config, (page == 1), false);
        page_box.appendChild(left);

        for (var i=1;i<=pages;i++) {
            var li = make_button(i, i, config, false, (page == i));
            page_box.appendChild(li);
        }

        var right = make_button("&raquo;", (pages>page?page+1:page), config, (page == pages), false);
        page_box.appendChild(right);
        if (box.childNodes.length) {
            while (box.childNodes.length > 1) {
                box.removeChild(box.childNodes[0]);
            }
            box.replaceChild(page_box, box.childNodes[0]);
        } else {
            box.appendChild(page_box);
        }
    }

    // make rows per page selector
    // if (!(typeof config.page_options == "boolean" && !config.page_options)) {
    //     if (typeof config.page_options == "undefined") {
    //         config.page_options = [
    //             { value: 5,  text: '5'   },
    //             { value: 10, text: '10'  },
    //             { value: 20, text: '20'  },
    //             { value: 50, text: '50'  },
    //             { value: 100,text: '100' },
    //             { value: 0,  text: 'All' }
    //         ];
    //     }
    //     var options = config.page_options;
    //     var select = document.createElement("select");
    //     for (var i=0;i<options.length;i++) {
    //         var o = document.createElement("option");
    //         o.value = options[i].value;
    //         o.text = options[i].text;
    //         select.appendChild(o);
    //     }
    //     select.value = rows_per_page;
    //     select.addEventListener("change", function () {
    //         config.rows_per_page = this.value;
    //         paginator(config);
    //     }, false);
    //     box.appendChild(select);
    // }

    // status message
    // var stat = document.createElement("span");
    // stat.innerHTML = "On page " + page + " of " + pages
    //     + ", showing rows " + (((page-1)*rows_per_page)+1)
    //     + " to " + (trs.length<page*rows_per_page||rows_per_page==0?trs.length:page*rows_per_page)
    //     + " of " + trs.length;
    // box.appendChild(stat);

    var stat = document.createElement("span");
    stat.innerHTML = "Showing " +  (trs.length<page*rows_per_page||rows_per_page==0?trs.length:page*rows_per_page)
        + " of " + trs.length;
    box.appendChild(stat);

    // hide pagination if disabled
    if (config.disable) {
        if (typeof box["data-display"] == "undefined") {
            box["data-display"] = box.style.display||"";
        }
        box.style.display = "none";
    } else {
        if (box.style.display == "none") {
            box.style.display = box["data-display"]||"";
        }
    }

    // run tail function
    if (typeof config.tail_call == "function") {
        config.tail_call(config);
    }

    return box;
}



$(document).ready(function() {

  initSwiperSliders();
  handleSwiperResize();
  
}); // document ready

$( window ).resize(function() {
  debounce_loading(handleSwiperResize());
});